import { render, staticRenderFns } from "./proficiencies.vue?vue&type=template&id=3fa45aef&scoped=true&"
import script from "./proficiencies.vue?vue&type=script&lang=js&"
export * from "./proficiencies.vue?vue&type=script&lang=js&"
import style0 from "./proficiencies.vue?vue&type=style&index=0&id=3fa45aef&lang=scss&scoped=true&"
import style1 from "./proficiencies.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa45aef",
  null
  
)

export default component.exports